import { render, staticRenderFns } from "./newcollection.vue?vue&type=template&id=9455cc1e&scoped=true&"
import script from "./newcollection.vue?vue&type=script&lang=js&"
export * from "./newcollection.vue?vue&type=script&lang=js&"
import style0 from "./newcollection.vue?vue&type=style&index=0&id=9455cc1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9455cc1e",
  null
  
)

export default component.exports